import React from 'react';
import {CAMPAIGN_DETAIL_FIELD_LIST} from "../../constants/campaign.constant";
import EditFacebookAdCampaign from "./edit-ad-campaign";

const CampaignDetail = ({campaign, isTable = true, afterEditAdCampaignAction}) => {

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center w-full mt-2">
                    <div className={'text-xl'}>
                        Campaign
                    </div>
                </div>

            </div>

            <div className="w-full mt-4 -ml-2">

                {campaign && isTable &&
                    <table className="w-full">
                        <tbody className="">
                        {CAMPAIGN_DETAIL_FIELD_LIST?.map((campaignField, rowIndex) => (
                            <tr key={`row-${rowIndex}`}>
                                <td className="p-2 m-auto w-40 font-bold">
                                    {campaignField?.label}
                                </td>

                                <td className="p-2 m-auto">
                                    {campaign[campaignField?.attribute]}
                                </td>
                            </tr>
                        ))}
                        </tbody>

                    </table>
                }

                {campaign && !isTable &&
                    <div className="w-full flex flex-wrap justify-start items-center">
                        {CAMPAIGN_DETAIL_FIELD_LIST?.map((campaignField, rowIndex) => (
                            <div key={`row-${rowIndex}`}
                                 className={'justify-center items-center m-2 py-2 px-6 bg-white rounded-lg'}>
                                <div className="mt-1 text-center text-purple-600 font-semibold">
                                    {campaign[campaignField?.attribute]}
                                </div>

                                <div className="text-gray-500 justify-center text-center mb-1">
                                    {campaignField?.label}
                                </div>
                            </div>
                        ))}

                        <div>
                            <EditFacebookAdCampaign
                                adCampaign={campaign}
                                afterEditAdCampaignAction={afterEditAdCampaignAction}/>
                        </div>
                    </div>
                }

            </div>

        </>
    )
}

export default CampaignDetail
